<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title fw-bold">{{ 'study-editor.view-transactions-modal.title' | translate }}</h4>
        <button type="button" class="btn-close" (click)="cancel()"></button>
    </div>
    <div class="modal-body">
        <jhi-transaction [gid]="gid" [lotId]="lotId"></jhi-transaction>
    </div>
    <div class="modal-footer">
        <button class="btn btn-primary" (click)="proceed()">{{ 'ok' | translate }}</button>
    </div>
</div>

